import { LinkTokens } from './types';

export const link: LinkTokens = {
  css: {
    borderBottom: '',
  },
  variants: {
    isUnderlined: {
      false: {
        borderBottom: 'unset',
        textDecoration: 'unset',
      },
      true: {
        ':hover': {
          borderBottom: '2px dotted',
          textDecoration: 'none',
        },
      },
    },
    type: {
      primary: {
        color: 'brandPrimary.1',
        borderColor: 'brandPrimary.1',
      },
      dotted: {
        color: 'brandPrimary.1',
        ',:hover': {
          textDecoration: 'underline',
          textDecorationStyle: 'dotted',
          textUnderlineOffset: '7px',
          lineHeight: 'bodies.base',
        },
        ':hover': {
          color: 'primary.70',
          borderBottom: 'none',
        },
      },
      legal: {
        color: 'neutrals.2',
        fontSize: 'body.0',
        borderBottomWidth: '2px',
        borderBottomStyle: 'dotted',
        borderBottomColor: 'neutrals.4',
        ':hover': {
          color: 'neutrals.0',
          borderColor: 'neutrals.0',
          textDecoration: '2px dotted',
          borderBottom: '2px dotted',
        },
      },
      legalUnderline: {
        color: 'neutrals.2',
        fontSize: 'body.0',
        borderBottomWidth: '2px',
        borderBottomStyle: 'dotted',
        borderBottomColor: 'neutrals.4',
        textDecoration: 'none',
        ':hover': {
          color: 'neutrals.0',
          borderColor: 'neutrals.0',
          borderBottom: '2px dotted',
          textDecoration: 'none',
        },
      },
    },
    disabled: {
      true: {
        color: 'neutrals.4',
        cursor: 'not-allowed',
        borderBottomWidth: '2px',
        borderBottomStyle: 'dotted',
        borderBottomColor: 'neutrals.4',
        ':hover': {
          textDecoration: 'none',
        },
      },
    },
  },
};
